/*
 * @Desc: 
 * @Author: lc
 * @Date: 2023-05-26 11:30:22
 * @LastEditors: lc
 * @LastEditTime: 2023-05-26 11:32:03
 */
/**
  * 权限菜单 接口的统一出口
  */
import axios from '.././http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块，把请求字段直接映射过来


// 接口请求地址
const api = '/c-api/';

const listtype = {
    // 列表
    list () {
        return axios.get(api + 'listtype/list')
    },
    // 添加
    create (params) {
        return axios.post(api + 'listtype/create', qs.stringify(params))
    },
    // 修改
    edit (params) {
        return axios.post(api + 'listtype/edit', qs.stringify(params))
    },
    // 单个查看
    detail (params) {
        return axios.get(api + 'listtype/detail', { params: params })
    },
    // 删除
    remove (params) {
        return axios.post(api + 'listtype/remove', qs.stringify(params))
    },
}


// 导出接口
export default listtype